import {ApiClient} from '@hconnect/apiclient'
import type {User} from '@hconnect/common/types'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'

const QueryKey = 'dalog-user-search'
const CACHE_TIME_IN_MS = 1000 * 60

type UseDalogUserSearchOptions = Omit<UseQueryOptions<User[], AxiosError>, 'queryKey' | 'queryFn'>

export const useDalogUserSearch = (
  plantUpmId: string,
  namePattern: string | undefined,
  options?: UseDalogUserSearchOptions
) => {
  return useQuery<User[], AxiosError>({
    queryKey: [QueryKey, namePattern, plantUpmId],
    queryFn: async ({signal}) => {
      if (!plantUpmId || !namePattern) {
        return []
      }

      const path = `${TasksApiPath.DALOG_ACTIONS}/${plantUpmId}/users`
      const response = await ApiClient.axiosInstance.get<User[]>(path, {
        params: {namePattern},
        signal
      })

      return response.data
    },
    gcTime: CACHE_TIME_IN_MS,
    refetchOnWindowFocus: false,
    ...options
  })
}
